var tabKeyPressed = false;
window.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    tabKeyPressed = true;
  }
});
window.addEventListener('mousedown', () => {
  tabKeyPressed = false;
});
window.addEventListener('touchstart', () => {
  tabKeyPressed = false;
});
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        this.card = this.querySelector('.product_card_wrap.card'); 
        if(this.card){
          this.card.addEventListener('mouseenter', this.onCardMouseEnter.bind(this));
          this.card.addEventListener('mouseleave', this.onCardMouseLeave.bind(this));
          this.card.addEventListener('focusin', this.onCardMouseEnter.bind(this));
          this.card.addEventListener('focus', this.onCardMouseLeave.bind(this));
          this.addEventListener('load', this.onDataLoad());
        }
      } 
      onCardMouseLeave(){
        if (window.innerWidth < 992 || document.body.classList.contains('show_variant_default')) return;
        let wrapper = this.querySelector('.bz_card_variant');
        if(wrapper) wrapper.style.removeProperty('bottom');
    
        let action_btn = this.querySelector('.action_both_btn');
        if(action_btn || wrapper) { 
            let action_btn_count = (wrapper?.clientHeight || 0) + 15;
            if(action_btn) action_btn.style.setProperty('bottom', '-' + action_btn_count + 'px');
            this.card.classList.remove('for_card_space');
        } else {
            if(action_btn) action_btn.style.removeProperty('bottom');
        }
        
      }
      onCardMouseEnter(){
        if (window.innerWidth < 992 || document.body.classList.contains('show_variant_default')) return;
        let wrapper = this.querySelector('.bz_card_variant');
        if(wrapper) wrapper.style.setProperty('bottom', '-' + wrapper.clientHeight + 'px');
    
        let action_btn = this.querySelector('.action_both_btn');
        if(action_btn || wrapper) { 
            let action_btn_count = (wrapper?.clientHeight || 0) + (action_btn?.clientHeight || 0);
            if(action_btn) action_btn.style.setProperty('bottom', '-' + action_btn_count + 'px');
            this.card.classList.add('for_card_space');
        } else if (action_btn) {
            action_btn.style.setProperty('bottom', '-' + action_btn.clientHeight + 'px');
        }        
      }

      onDataLoad(){
        if (document.body.classList.contains('show_variant_default')) return;
        let wrapper = this.querySelector('.bz_card_variant');
        let action_btn = this.querySelector('.action_both_btn');
        if(action_btn && wrapper) { 
          let action_btn_count = wrapper.clientHeight + 15;
          action_btn.style.setProperty('bottom', '-'+action_btn_count+'px');
        }
      }
  
      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        const variant = this.getSelectedVariant(this);
        if (this.dataset.layout == 'card') this.updateCardMedia(variant?.featured_media?.id);
        this.initCardMediaSlider();
      }

      initCardMediaSlider() {
        if (this.dataset.layout !== 'card' || this._fcSwiper) return;
        const el = this.querySelector('[data-fc-media], .card-media-slider');
        if (!el || el.querySelectorAll('.swiper-slide').length < 2) return;

        const boot = () => {
          if (typeof Swiper === 'undefined') return setTimeout(boot, 50);
          if (this._fcSwiper || el.swiper) return;
          const slideCount = el.querySelectorAll('.swiper-slide').length;
          this._fcSwiper = new Swiper(el, {
            nested: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 400,
            grabCursor: true,
            simulateTouch: true,
            allowTouchMove: true,
            touchStartPreventDefault: false,
            preventClicks: true,
            preventClicksPropagation: true,
            a11y: {
              slideLabelMessage: null,
            },
            pagination: {
              el: el.querySelector('[data-fc-dots], .card-media-slider__dots'),
              clickable: true,
              /* Many variant images → many dots; keep a compact window so Choose options label never wraps */
              dynamicBullets: slideCount > 4,
              dynamicMainBullets: 2,
            },
          });
          const card = this.querySelector('[data-fc-card]');
          const startId = card?.getAttribute('data-fc-start');
          if (startId) this.slideCardMedia(startId);
        };
        boot();
      }

      slideCardMedia(mediaId) {
        if (!this._fcSwiper || !mediaId) return false;
        const slide = this.querySelector(`[data-fc-media] [data-media-id$="-${mediaId}"], .card-media-slider [data-media-id$="-${mediaId}"]`);
        if (!slide) return false;
        this._fcSwiper.slideTo(+slide.getAttribute('data-fc-idx') || 0);
        return true;
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct && this.dataset.layout != 'card';
 
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct && this.dataset.layout != 'card'
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
            focusId: target.dataset.optionValueId,
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback, focusId }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            if (this.dataset.layout == 'card') {
              const parsed = new DOMParser().parseFromString(responseText, 'text/html');
              const html =
                parsed.getElementById(this.id) ||
                parsed.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`) ||
                parsed.querySelector('product-info') ||
                parsed;

              this.alignFetchedCardSection(html);

              const trigger = document.getElementById(targetId);
              const loopIdx = parseInt(trigger?.getAttribute('data-forloop-index'), 10);
              if (!Number.isNaN(loopIdx) && loopIdx >= 0) {
                const suffix = String(loopIdx);
                html.querySelectorAll('.wc_selector_operation, input[type="radio"][name]').forEach((input) => {
                  input.setAttribute('data-forloop-index', suffix);
                  let name = (input.getAttribute('name') || '').replace(/-$/, '');
                  const re = new RegExp('(-)?' + suffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$');
                  if (!re.test(name)) name = name + '-' + suffix;
                  input.setAttribute('name', name);
                });
              }
              callback(html);
            }else{
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              if(html.tagNam == 'PRODUCT-INFO') html.setAttribute('data-update-url', 'false')
              else if(html.querySelector('product-info') && this.dataset.isQuickView) {
                html.querySelector('product-info').setAttribute('data-update-url', 'false');
                html.querySelector('product-info').setAttribute('data-is-quick-view', 'true');
              }
              callback(html);
            }
          })
          .then(() => { 
            if (tabKeyPressed) {
              this.dataset.layout != 'card' ? this.querySelector(`#${targetId}`)?.focus() : this.querySelector('input[data-option-value-id="'+focusId+'"]')?.focus();
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
            } else {
              console.error(error);
            }
          });
      }

      /* Map ajax-card-product section ids onto this card section id (fixes multi-option variants) */
      alignFetchedCardSection(htmlRoot) {
        if (!htmlRoot || !htmlRoot.getAttribute) return;
        const from = htmlRoot.getAttribute('data-section');
        const to = this.dataset.section;
        if (!from || !to || from === to) return;

        const swap = (val) => (val && val.indexOf(from) !== -1 ? val.split(from).join(to) : val);
        if (htmlRoot.id) htmlRoot.id = swap(htmlRoot.id);
        htmlRoot.setAttribute('data-section', to);

        htmlRoot.querySelectorAll('[id], [name], [form], [for]').forEach((el) => {
          ['id', 'name', 'form', 'for'].forEach((attr) => {
            if (!el.hasAttribute(attr)) return;
            el.setAttribute(attr, swap(el.getAttribute(attr)));
          });
        });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML || productInfoNode.querySelector('color-swatch [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.dataset.originalSection}`); //params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        return `${url}${url.indexOf('?') >= 0 ? '&' : '?'}${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
      updateCardVendor(vendorName) {
        const card = this.closest('.card') || this.querySelector('.card');
        if (!card) return;
      
        const vendorElement = card.querySelector('.card_vendor');
        if (vendorElement) {
          vendorElement.textContent = vendorName;
        }
      }
      updateCardProductType(productType) {
        const productTypeElement = this.querySelector('.card_type');
        if (productTypeElement) {
          productTypeElement.textContent = productType;
        }
      }
      updateCardTitle(productTitle, productUrl) {
        const productTitleElement = this.querySelector('.full-unstyled-link');
        if (!productTitleElement) return;

        productTitleElement.textContent = productTitle;

        if (productUrl) {
          productTitleElement.setAttribute(
            'href',
            `${productUrl}`
          );
        }
      }
      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          const vendorName = html.querySelector('.card_vendor')?.textContent;
          if (vendorName) {
            this.updateCardVendor(vendorName);
          } else {
            this.updateCardVendor('');
          }

          const productType = html.querySelector('.card_type')?.textContent;
          if (productType) {
            this.updateCardProductType(productType);
          } else {
            this.updateCardProductType('');
          }

          const titleElement = html.querySelector('.full-unstyled-link');
          if (titleElement) {
            const productTitle = titleElement.textContent;
            const productUrl = titleElement.getAttribute('href');

            this.updateCardTitle(productTitle, productUrl);
          }

          if (this.dataset.layout == 'card') {
            if (this.dataset.url != productUrl) {
              const productMediaItem = html.querySelectorAll(".product__media-item");
              productMediaItem.forEach((mediaItem) => {
                mediaItem.dataset.mediaId = this.replaceStringBeforeLastDash(mediaItem.dataset.mediaId, `${this.dataset.section}-${this.dataset.productId}`);
              });

              const thisMedia = this.querySelector(".card__inner");
              const newMedia = html.querySelector(".card__inner");

              if (thisMedia && newMedia) {
                this._fcSwiper = null;
                thisMedia.innerHTML = newMedia.innerHTML;
                this.initCardMediaSlider();
              }
            }
            this.dataset.url = productUrl;
          }

          
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          
          if (!variant) {
            this.setUnavailable();
            return;
          }
          if (variant.id && this.dataset.isQuickView) {
            this.querySelector('input.product-variant-id[name="id"]').setAttribute('value', variant.id);
          }
          
          this.updateMedia(html, variant?.featured_media?.id);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.querySelector(`#${id}-${this.sectionId}`);
            var main_url_1 = `#${id}-${this.dataset.section}`;
            var main_url_2 = `#${id}-quickadd-${this.dataset.section}`;
            const destination = this.querySelector(main_url_1) ? this.querySelector(main_url_1) : this.querySelector(main_url_2);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          this.querySelector('.card_pro_details');
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('variant-title', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('badge', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);

          if (this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) {
            this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          } else {
            this.querySelector(`#Quantity-Rules-quickadd-${this.dataset.section}`)?.classList.remove('hidden');
          }
          if (this.querySelector(`#Volume-Note-${this.dataset.section}`)) {
            this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
          } else {
            this.querySelector(`#Volume-Note-quickadd-${this.dataset.section}`)?.classList.remove('hidden');
          }
          if (html.querySelector(`#ProductSubmitButton-${this.sectionId}`)) {
            html.querySelectorAll('.product-form__input.product-form__input--pill, .product-form__input.product-form__input--swatch, .product_form_input.product-form__input, .product-form__input.product-form__input--dropdown, .product_form_input.product-form__varimg').forEach(function(self, index){
             let radioCheckedValue = self.querySelector('input[type="radio"]:checked');
    
              if (radioCheckedValue) {
                let value = radioCheckedValue.getAttribute('value');
                if (value !== variant.options[index]) {
                  fullSelected = 0;
                }
              }


              if (self.querySelector('select')) {
                const selectedOption = self.querySelector('select').selectedOptions[0];
                var selectedValue = selectedOption.getAttribute('value');
                if (selectedValue !== variant.options[index]) {
                  fullSelected = 0;
                }
              }
            
            });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(
                true,
                window.variantStrings.unavailable
              );
            } else {
              this.productForm?.toggleSubmitButton(
                html.querySelector(`#ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
            }
          } else {
            var fullSelected = 1;
            html.querySelectorAll('.product-form__input.product-form__input--pill, .product_form_input.product-form__input').forEach(function(self, index){
               if (self.querySelector('input[type="radio"]:checked')){
                if (self.querySelector('input[type="radio"]:checked').getAttribute('value') !== variant.options[index]) {
                  fullSelected = 0;
                }
               }
               if (self.querySelector('select')) {
                const selectedOption = self.querySelector('select').selectedOptions[0];
                var selectedValue = selectedOption.getAttribute('value');
                if (selectedValue !== variant.options[index]) {
                  fullSelected = 0;
                }

              }
            });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(
                true,
                window.variantStrings.unavailable
              );
            } else {
              this.productForm?.toggleSubmitButton(
                html.querySelector(`#ProductSubmitButton-quickadd-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
            }
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        const selecter = this.dataset.layout == 'card' ? this.dataset.section + "-" + this.dataset.productId : this.dataset.section
        this.querySelectorAll(
          `#product-form-${selecter}, #product-form-installment-${selecter}`
        ).forEach((productForm) => { 
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        this.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateCardMedia(variantFeaturedMediaId){
        if (!variantFeaturedMediaId) return;

        const hasSlider = this.querySelector('[data-fc-media], .card-media-slider');
        if (hasSlider) {
          if (!this._fcSwiper) this.initCardMediaSlider();
          if (this.slideCardMedia(variantFeaturedMediaId)) return;
          // Media not in slider slides — do not prepend into swiper-wrapper
          return;
        }

        const card = this.closest('.card') || this.querySelector('.card');
        if (!card) return;
        const newMedia = card.querySelector(
          `[data-media-id="${this.dataset.section}-${this.dataset.productId}-${variantFeaturedMediaId}"]`
        );
        if (!newMedia) return;
        const parent = newMedia.parentElement;
        if (!parent || parent.firstChild == newMedia) return;
        parent.prepend(newMedia);
      }

      replaceStringBeforeLastDash(str, replacement) {
        // Find the position of the last dash
        const lastDashIndex = str.lastIndexOf('-');
        
        // If there's no dash, return the string unchanged
        if (lastDashIndex === -1) {
          return str;
        }
      
        // Extract everything after the last dash and prepend the replacement
        return replacement + str.substring(lastDashIndex);
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return; 
        if (this.dataset.layout == 'card') { 
          this.updateCardMedia(variantFeaturedMediaId);
        } else {

          
          const mediaGallerySource = this.querySelector('media-gallery ul');
          const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
  
          const refreshSourceData = () => {
            if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
            const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
            const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
            const sourceMap = new Map(
              mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
            );
            return [mediaGallerySourceItems, sourceSet, sourceMap];
          };
  
          if (mediaGallerySource && mediaGalleryDestination) {
            let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            const mediaGalleryDestinationItems = Array.from(
              mediaGalleryDestination.querySelectorAll('li[data-media-id]')
            );
            const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
            let shouldRefresh = false;
  
            // add items from new data not present in DOM
            for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
              if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
                mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                shouldRefresh = true;
              }
            }
  
            // remove items from DOM not present in new data
            for (let i = 0; i < mediaGallerySourceItems.length; i++) {
              if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
                mediaGallerySourceItems[i].remove();
                shouldRefresh = true;
              }
            }
  
            // refresh
            if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
  
            // if media galleries don't match, sort to match new data order
            mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
              const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
  
              if (sourceData && sourceData.index !== destinationIndex) {
                mediaGallerySource.insertBefore(
                  sourceData.item,
                  mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
                );
  
                // refresh source now that it has been modified
                [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
              }
            });
          }
  
          // set featured media as active in the media gallery
          const selector = this.dataset.isQuickView ? 'quickadd-' : '';
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${selector}${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );
  
          // update media modal
          const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
          const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
          if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;

        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
      
        const loadingSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');
      
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            const loadingSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
          });
      }
      

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.querySelector(`#Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects') || this.querySelector('color-swatch');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

// homepage product grid variant change to not remove checked in the radio button

document.addEventListener("change", function (event) {
  if (event.target.classList.contains("wc_selector_operation")) {
    let closestFeature = event.target.closest(".featured_collection_home");
    if (!closestFeature) return;

    let dataId = closestFeature.getAttribute("data-id");

    setTimeout(() => {
      let radioButtons = closestFeature.querySelectorAll(
        ".wc_selector_operation"
      );
      radioButtons.forEach((radio) => {
        let originalName =
          radio.getAttribute("data-original-name") ||
          radio.getAttribute("name");
        radio.setAttribute("data-original-name", originalName);
        radio.setAttribute("name", `${originalName}_${dataId}`);
      });
    }, 1000); 
  }
});
/* Card model-view toggle — [data-fc-model] + [data-fc-model-btn] (section setting) */
document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-fc-model-btn]');
  if (!btn) return;
  const root = btn.closest('[data-fc-model]');
  if (!root) return;
  const on = btn.getAttribute('aria-pressed') !== 'true';
  root.querySelectorAll('[data-fc-model-btn]').forEach((b) => {
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.classList.toggle('active', on);
  });
  root.querySelectorAll('product-info[data-layout="card"]').forEach((pi) => {
    const card = pi.querySelector('[data-fc-card]');
    if (pi._fcSwiper && card) {
      const sid = on ? card.getAttribute('data-fc-second') : card.getAttribute('data-fc-first');
      if (sid) pi.slideCardMedia(sid);
      else pi._fcSwiper.slideTo(on ? 1 : 0);
      return;
    }
    pi.querySelectorAll('.card_image_wrapper').forEach((w) => {
      const imgs = w.querySelectorAll(':scope > img, :scope > video');
      if (imgs[1]) {
        imgs[0].style.opacity = on ? '0' : '';
        imgs[1].style.opacity = on ? '1' : '';
      }
    });
  });
});